import { useState, type ReactNode } from 'react';

export interface PhotoScene {
  id: string;
  small: string;
  large: string;
  /** Какую часть кадра держать в рамке (object-position). */
  position?: string;
}

/** Номер сцены: при каждом открытии приложения — следующий по кругу (без повторов подряд). Без хранилища — случайный. */
function nextScene(key: string, n: number): number {
  try {
    const prev = Number(window.localStorage.getItem(key));
    const next = Number.isInteger(prev) && prev >= 0 ? (prev + 1) % n : Math.floor(Math.random() * n);
    window.localStorage.setItem(key, String(next));
    return next;
  } catch {
    return Math.floor(Math.random() * n);
  }
}
// Выбирается один раз за открытие приложения: возврат на экран не меняет картинку.
const chosen = new Map<string, number>();

/**
 * Фото-фон баннера: сцены меняются по кругу при каждом открытии приложения. Пока фото грузится
 * (или если не загрузилось), виден нарисованный фон `fallback`. Затемнение задаётся классом `shadeClass`.
 */
export function PhotoBackdrop({ scenes, storageKey, fallback, shadeClass }: { scenes: PhotoScene[]; storageKey: string; fallback: ReactNode; shadeClass: string }) {
  const [scene] = useState(() => {
    if (!chosen.has(storageKey)) chosen.set(storageKey, nextScene(storageKey, scenes.length));
    return scenes[chosen.get(storageKey)! % scenes.length]!;
  });
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  return (
    <>
      {fallback}
      {failed ? null : (
        <img
          className={`backdrop-photo ${loaded ? 'loaded' : ''}`}
          src={scene.small}
          srcSet={`${scene.small} 720w, ${scene.large} 1200w`}
          sizes="(min-width: 720px) 560px, 100vw"
          alt=""
          decoding="async"
          style={scene.position ? { objectPosition: scene.position } : undefined}
          onLoad={() => setLoaded(true)}
          onError={() => setFailed(true)}
          data-scene={scene.id}
        />
      )}
      <span className={shadeClass} aria-hidden />
    </>
  );
}
